import React, { useState} from "react";


import TimelineIntroImage from "../TimelineIntroImage";
import TimelineBodyText from "../TimelineBodyText";
import TimelinePresentationImage from "../TimelinePresentationImage";

import "./timeline-section.scss";
import { useTransform } from "framer-motion";


const TimelineSection = ({fields, sectionIndex, readMoreHandler, posThreshold, scrollYProgress, durPct, debugMode}) => {
  const [expanded, setExpanded] = useState(false);

  const onReadMore = () => {
    setExpanded(!expanded);
    setTimeout(readMoreHandler, 400);
  };

  const xTransform = useTransform( scrollYProgress, [0, posThreshold - durPct, posThreshold, 1], ['1em','1em','0em','0em'] );
  
  return (
    <section
      className={`timeline-section ${
        expanded ? "timeline-section--expanded" : ""
      }`}
      data-anchor={fields?.anchor?.value}
      data-index={sectionIndex}
    >
        {debugMode && <h6>{fields?.anchor?.value} - {Math.trunc(posThreshold*100)+'%'}</h6>}

        {fields.media1 && scrollYProgress && (durPct > 0) && posThreshold > 0 && <TimelineIntroImage 
          sectionIndex={sectionIndex} 
          media={fields.media1} 
          subHeadline={fields.subHeadline} 
          xTransform={xTransform} />}
      
        {fields.bodyTextPart1?.value && <TimelineBodyText 
          sectionIndex={sectionIndex} 
          bodyTextPart1={fields.bodyTextPart1} 
          bodyTextPart2={fields.bodyTextPart2} 
          onReadMore={onReadMore} 
        />}
      
        {fields.media2 && <TimelinePresentationImage 
          sectionIndex={sectionIndex} 
          media={fields.media2} 
          mediaCaption={fields.media2Caption} 
          presentationSlides={fields.presentationSlides} 
          headline={fields.headline.value} 
          isDecade={fields.isDecade.value} 
        />}
      
    </section>
  );
};

export default TimelineSection;
